<nb-accordion multi [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-accordion-item *ngFor="let itemS of sections; let i = index">
    <nb-accordion-item-header>
      <span> {{ i + 1 }}: {{ itemS.title }} </span>
      <nb-badge
        text="{{ itemS.lectures ? itemS.lectures.length : '0' }}"
        status="{{ itemS.noLecture ? 'info' : 'danger' }}"
        position="top right"
        class="badge-lecture"
      >
      </nb-badge>
    </nb-accordion-item-header>

    <nb-accordion-item-body [nbSpinner]="loading" nbSpinnerStatus="info">
      <ngx-preview-lectures
        [sourceType]="sourceType"
        [lectureContentId]="lectureContentId"
        [courseId]="courseId"
        [sectionId]="itemS.id"
        [lectures]="itemS.lectures"
        (onOpenSourceContent)="openSourceContent($event)"
        (onEnrollCourse)="enrollCourse()"
      >
      </ngx-preview-lectures>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
